import { mainAxios } from "../mainAxios";
import { getDefaultHeaders, getErrorMessage } from "./mainService";

export const obtenerRenovacionesPendientes = async (payload) => {
  try {
    const response = await mainAxios.post(
      `/v1/emision/renovaciones`,
      payload,
      getDefaultHeaders()
    );

    return response;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};


export const accionarRenovaciones = async (payload) => {
  try {
    const response = await mainAxios.post(
      `/v1/emision/renovar`,
      payload,
      getDefaultHeaders()
    );

    return response;
  } catch (error) {
    throw new Error(getErrorMessage(error));
  }
};

export const emisionRenovarProductos = async () => {
    try {
        const response = await mainAxios.get(
            `/v1/emision/renovar/productos`,
            getDefaultHeaders()
        );

        return response;
    } catch (error) {
        throw new Error(getErrorMessage(error));
    }
};